var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m141.255 52h-106.51c-19.159 0-34.745 15.586-34.745 34.745v106.51c0 19.159 15.586 34.745 34.745 34.745h106.51c19.159 0 34.745-15.586 34.745-34.745v-106.51c0-19.159-15.586-34.745-34.745-34.745z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m141.255 284h-106.51c-19.159 0-34.745 15.586-34.745 34.745v106.51c0 19.159 15.586 34.745 34.745 34.745h106.51c19.159 0 34.745-15.586 34.745-34.745v-106.51c0-19.159-15.586-34.745-34.745-34.745z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m496 132h-256c-8.836 0-16-7.164-16-16s7.164-16 16-16h256c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m408 192h-168c-8.836 0-16-7.164-16-16s7.164-16 16-16h168c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m496 360h-256c-8.836 0-16-7.164-16-16s7.164-16 16-16h256c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m408 424h-168c-8.836 0-16-7.164-16-16s7.164-16 16-16h168c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.4d060290.svg";
export { ForwardRef as ReactComponent };